export default __webpack_public_path__ + "static/media/banner4.6513e534.jpeg";